import styled from "styled-components";
import MediaQuery from "../MediaQuery";

const Card = styled.div`
  background: #fff;
  width: 100%;
  border-radius: 5px;
  box-shadow: 0 10px 30px rgba(44, 80, 89, 0.09);
  border: 1px solid rgba(44, 80, 89, 0.06);
  padding: 30px;
  ${MediaQuery.tablet`
    padding: 15px;
  `};
`;

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card/index.js